module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "wrapper-left"
  }, [_c('vertical-tab', {
    model: {
      value: (_vm.playerIndex),
      callback: function($$v) {
        _vm.playerIndex = $$v
      },
      expression: "playerIndex"
    }
  }, _vm._l((_vm.players), function(player, index) {
    return _c('vertical-tab-pane', {
      key: player.uuid,
      attrs: {
        "label": player.displayName,
        "name": index + ''
      }
    }, [_c('el-tag', {
      attrs: {
        "type": player.isOnline ? 'success' : 'gray'
      },
      slot: "right"
    }, [_vm._v(_vm._s(player.isOnline ? 'Online' : 'Offline'))])], 1)
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "wrapper-right"
  }, [_c('el-form', {
    attrs: {
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "OP"
    }
  }, [_c('el-switch', {
    attrs: {
      "disabled": _vm.server.status !== 'started'
    },
    on: {
      "change": _vm.changeOp
    },
    model: {
      value: (_vm.player.isOp),
      callback: function($$v) {
        _vm.player.isOp = $$v
      },
      expression: "player.isOp"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Status"
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.player.isOnline ? 'success' : 'gray'
    }
  }, [_vm._v(_vm._s(_vm.player.isOnline ? 'Online' : 'Offline'))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('object-dump', {
    attrs: {
      "value": _vm._f("filterPlayer")(_vm.player),
      "indent": 0
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4a5f069c"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/server/Player.vue
// module id = 163
// module chunks = 1